jQuery('#lightsOnRightContent').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    dots: true,
    appendDots: jQuery('#lightsOnRightContentDots'),
    infinite: false,
});

jQuery('.staggered-content-lights-on-right .image-container .hotspot').on('click', function() {
    switch (jQuery('.staggered-content-lights-on-right .image-container').attr('data-status')) {
        case 'off':
            jQuery('.staggered-content-lights-on-right .image-container').attr('data-status', 'semi');
            jQuery('.staggered-content-lights-on-right .image-container .off').fadeOut();
            jQuery('.staggered-content-lights-on-right .image-container .semi').fadeIn();
            break;
        case 'semi':
            jQuery('.staggered-content-lights-on-right .image-container').attr('data-status', 'on');
            jQuery('.staggered-content-lights-on-right .image-container .semi').fadeOut();
            jQuery('.staggered-content-lights-on-right .image-container .on').fadeIn();
            break;
        case 'on':
            jQuery('.staggered-content-lights-on-right .image-container').attr('data-status', 'off');
            jQuery('.staggered-content-lights-on-right .image-container .on').fadeOut();
            jQuery('.staggered-content-lights-on-right .image-container .off').fadeIn();
            break;
    }
});